/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_TitleInputs */



/**
* | output |
* | --- |
* | "Developer Portal" |
*
* @param {Developer_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_title = /** @type {((inputs?: Developer_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Portail développeur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Portal de desarrollador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Portal do Desenvolvedor")
	if (locale === "it") return /** @type {LocalizedString} */ ("Portale Sviluppatore")
	return /** @type {LocalizedString} */ ("Developer Portal")
});